import { Providers } from './providers';

export default function App() {
  return <Providers />;
}
